import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { renderField, renderRadioButton } from "../components";
import { validateRequired } from "../validation";

const Employee = ({ renderValue }) => (
  <Fragment>
    <span style={{ fontWeight: "bold" }}>{"(A) EMPLOYEE'S PARTICULARS"}</span>
    <table style={{ borderCollapse: "collapse", width: "100%" }}>
      <tbody>
        <tr>
          <td style={{ border: "1px solid #000", padding: 5 }} colSpan={4}>
            Full Name of Proposed Insured in Block (as shown in NRIC)
            <br />
            <div style={{ paddingTop: 5 }} id="RO_EmployeeName">
              {renderValue({
                fieldName: "EmployeeName",
                fieldFormat: "text",
              })}
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            Nationality
            <div style={{ paddingTop: 5 }}>
              <Field
                name="Nationality"
                type="text"
                component={renderField}
                validate={validateRequired}
                style={{ width: "100%" }}
              />
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            <div style={{ textAlign: "center" }}>Race</div>
            <div style={{ paddingTop: 5 }}>
              <Field
                name="Race"
                type="radio"
                component={renderRadioButton}
                validate={validateRequired}
                value="Asian"
              />
              <Field
                name="Race"
                type="radio"
                component={renderRadioButton}
                validate={validateRequired}
                value="Others"
              />
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            Country of Residence
            <div style={{ paddingTop: 5 }}>
              <Field
                name="CountryOfResidence"
                type="text"
                component={renderField}
                validate={validateRequired}
                style={{ width: "100%" }}
              />
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5, textAlign: "center" }}>
            Height (cm)
            <div style={{ paddingTop: 5 }}>
              <Field
                name="Height"
                type="text"
                component={renderField}
                validate={validateRequired}
                style={{ width: 50 }}
              />
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5, textAlign: "center" }}>
            Weight (kg)
            <div style={{ paddingTop: 5 }}>
              <Field
                name="Weight"
                type="text"
                component={renderField}
                validate={validateRequired}
                style={{ width: 50 }}
              />
            </div>
          </td>
        </tr>
        <tr>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            NRIC / Passport No.
            <div style={{ paddingTop: 5 }} id="RO_Identification">
              {renderValue({
                fieldName: "Identification",
                fieldFormat: "text",
              })}
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            Date of Birth
            <div style={{ paddingTop: 5 }} id="RO_BirthDate">
              {renderValue({
                fieldName: "BirthDate",
                fieldFormat: "date",
                dateFormat: "YYYY-MM-DD",
              })}
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            Gender
            <br />
            <div style={{ paddingTop: 5 }} id="RO_Gender">
              {renderValue({ fieldName: "Gender", fieldFormat: "text" })}
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }}>
            Marital Status
            <div style={{ paddingTop: 5 }} id="RO_MaritalStatus">
              {renderValue({
                fieldName: "MaritalStatus",
                fieldFormat: "text",
              })}
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }} colSpan={3}>
            Occupation - Exact Duties
            <div style={{ paddingTop: 5 }}>
              <Field
                name="JobTitle"
                type="text"
                component={renderField}
                validate={validateRequired}
                style={{ width: "100%" }}
              />
            </div>
          </td>
          <td style={{ border: "1px solid #000", padding: 5 }} colSpan={2}>
            Date of Employment
            <div style={{ paddingTop: 5 }} id="RO_JoinDate">
              {renderValue({
                fieldName: "JoinDate",
                fieldFormat: "date",
                dateFormat: "YYYY-MM-DD",
              })}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    &nbsp;
    <br />
  </Fragment>
);

Employee.propTypes = {
  renderValue: PropTypes.func.isRequired,
};

export default Employee;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/AVIVAHD201910/Employee.js